<!-- Responsibility: Admin COMMERCE tab - Monetization and auditing.
Scope: Catalog and Billing. -->
<admin-commerce-tab>
  <div class="admin-tab-content">
    <div class="admin-grid">
      <admin-commerce-card
        commerce-plans={ props.state.commercePlans }
        commerce-message={ props.state.commerceMessage }
        on-save-plan={ props.onSavePlan }
      ></admin-commerce-card>

      <admin-billing-card
        commerce={ props.state.commerce }
        billing-audit={ props.state.billingAudit }
        format-time={ props.helpers.formatTime }
      ></admin-billing-card>
    </div>
  </div>

  <script>
    import AdminCommerceCard from './admin-commerce-card.riot'
    import AdminBillingCard from './admin-billing-card.riot'

    export default {
      components: {
        AdminCommerceCard, AdminBillingCard
      }
    }
  </script>

  <style>
    .admin-tab-content { display: grid; gap: var(--space-lg); }
    .admin-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(350px, 1fr)); gap: var(--space-lg); }
  </style>
</admin-commerce-tab>
